import React from 'react';
import { Typography, Row, Col } from 'antd';
import Image from '../images/aguilasreales.jpg';
import Galeria from './Galeria';

const { Title, Text } = Typography;

const Kids = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh', // Ensure the page takes up the full viewport height
      }}
    >
      {/* Main Content */}
      <div style={{ flex: 1 }}>
        {/* Banner */}
        <div
          style={{
            width: '100%',
            height: '300px',
            backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${Image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Title
            level={1}
            style={{
              color: 'white',
              fontSize: '48px',
              textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
              fontFamily: 'Outfit',
            }}
          >
            Kids
          </Title>
        </div>

        {/* Content */}
        <div style={{ padding: '40px' }}>
          <Row gutter={64} align="middle">
            {/* Left Column */}
            <Col xs={24} md={12}>
              <Title
                level={2}
                style={{
                  fontSize: '40px',
                  fontFamily: 'Outfit',
                  color: 'rgba(0, 0, 0, 0.85)',
                }}
              >
                Águilas Reales Kids
              </Title>
              <Text
                style={{
                  fontSize: '20px',
                  lineHeight: '1.8',
                  fontFamily: 'Roboto',
                  color: 'rgba(0, 0, 0, 0.85)',
                }}
              >
                El ministerio de Águilas Reales tiene como objetivo guiar a los
                niños hacia una relación con Jesús y enseñarles valores
                cristianos, empatía, disciplina y fe. De esta manera, se busca
                formar una generación de niños apasionados por Dios, que
                impacten en el futuro inmediato a la sociedad argentina.
              </Text>
            </Col>
          </Row>
        </div>
      </div>

      {/* Galeria Component */}
      <Galeria
        folderId={process.env.REACT_APP_GOOGLE_DRIVE_KIDS_FOLDER_ID}
        title="Galería Kids"
      />
    </div>
  );
};

export default Kids;
